import { router } from 'expo-router';
import { useSetAtom } from 'jotai';
import { isNonMobileWeb } from 'smoothie';

import { showGuideMessagingModalAtom } from '../state/MessagingAtoms';

export const useShowGuideMessaging = () => {
    const setShowGuideMessagingModal = useSetAtom(showGuideMessagingModalAtom);

    return (show: boolean = true) => {
        setShowGuideMessagingModal(show);
        if (!isNonMobileWeb) {
            if (show) {
                router.navigate('/messaging/guide-messaging');
            } else {
                router.canGoBack() ? router.back() : router.navigate('/home');
            }
        }
    };
};
